//Search
export const AUDIT_SEARCH_START_LOADING = "AUDIT_SEARCH_START_LOADING";
export const AUDIT_SEARCH_END_LOADING = "AUDIT_SEARCH_END_LOADING";
export const AUDIT_SEARCH_LOADED = "AUDIT_SEARCH_LOADED";
export const SET_AUDIT_FILTER = "SET_AUDIT_FILTER";